export const RouteInformation = {
    homePage: '/',
    dashboardPage: '/app/dashboard',
    complaintsPage: '/app/complaints',
    notAssignedPage: '/app/not-assigned',
    profilePage: '/app/profile',
    settingsPage: '/app/settings',
    loginPage: '/auth/login',
    signupPage: '/auth/signup',
    unauthorizedPage: '/auth/unauthorized',
    recoverPasswordPage: '/auth/forgot-password',
    notFoundPage: '/auth/not-found',
    registerPage: '/auth/register',
    plansPage: '/auth/plans',
    surveyPage: '/survey'
}
